import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { CONTACT_INFO } from '../data/mock';
import { CheckCircle, Package, Mail, Phone, ArrowRight, Zap } from 'lucide-react';

const OrderConfirmationPage = () => {
  const orderNumber = `KV-${Date.now().toString().slice(-8)}`;

  useEffect(() => {
    document.title = 'Order Confirmed | Keto Vybe';
  }, []);

  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      
      <main className="pt-[160px] pb-20">
        <div className="max-w-2xl mx-auto px-4 text-center">
          {/* Success Icon */}
          <div className="w-24 h-24 bg-gradient-to-br from-vybe-600 to-cyan-500 rounded-full flex items-center justify-center mx-auto mb-8 shadow-glow-purple">
            <CheckCircle className="w-12 h-12 text-white" />
          </div>
          
          <h1 className="font-display text-3xl md:text-4xl text-white mb-4">
            Thank You for Your Order!
          </h1>
          
          <p className="text-slate-400 text-lg mb-8">
            Your order has been placed successfully. We've sent a confirmation email with your order details.
          </p>
          
          {/* Order Number */}
          <div className="bg-slate-800/50 p-6 rounded-2xl border border-slate-700/50 mb-8">
            <p className="text-slate-400 text-sm mb-2">Order Number</p>
            <p className="font-display text-2xl text-vybe-400 font-bold">{orderNumber}</p>
          </div>
          
          {/* Next Steps */}
          <div className="bg-vybe-600/10 p-8 rounded-2xl border border-vybe-500/30 mb-8 text-left">
            <h3 className="font-semibold text-white mb-4 flex items-center gap-2">
              <div className="w-8 h-8 bg-vybe-600 rounded-lg flex items-center justify-center">
                <Package className="w-4 h-4 text-white" />
              </div>
              What's Next?
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <span className="w-7 h-7 bg-gradient-to-br from-vybe-600 to-vybe-500 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0">1</span>
                <span className="text-slate-300">You'll receive an email confirmation shortly.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-7 h-7 bg-gradient-to-br from-vybe-600 to-vybe-500 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0">2</span>
                <span className="text-slate-300">We'll send you tracking information once your order ships.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-7 h-7 bg-gradient-to-br from-vybe-600 to-vybe-500 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0">3</span>
                <span className="text-slate-300">Expected delivery: 3-5 business days.</span>
              </li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div className="bg-slate-800/50 p-6 rounded-2xl border border-slate-700/50 mb-8">
            <h3 className="font-semibold text-white mb-4">Need Help?</h3>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
              <a 
                href={`tel:${CONTACT_INFO.phone.replace(/[^0-9]/g, '')}`}
                className="flex items-center gap-2 text-vybe-400 hover:text-vybe-300 transition-colors font-medium"
              >
                <Phone className="w-5 h-5" />
                {CONTACT_INFO.phone}
              </a>
              <a 
                href={`mailto:${CONTACT_INFO.email}`}
                className="flex items-center gap-2 text-cyan-400 hover:text-cyan-300 transition-colors font-medium"
              >
                <Mail className="w-5 h-5" />
                {CONTACT_INFO.email}
              </a>
            </div>
          </div>
          
          {/* Continue Shopping */}
          <Link 
            to="/shop"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-vybe-600 to-vybe-500 hover:from-vybe-500 hover:to-vybe-400 text-white font-bold rounded-full transition-all shadow-button"
          >
            Continue Shopping
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default OrderConfirmationPage;
